{
  "LABEL_MGMT": {
    "HEADER": "ലേബലുകൾ",
    "HEADER_BTN_TXT": "ലേബൽ ചേർക്കുക",
    "LOADING": "ലേബലുകൾ ലഭ്യമാക്കുന്നു",
    "DESCRIPTION": "Labels help you categorize and prioritize conversations and leads. You can assign a label to a conversation or contact using the side panel.",
    "LEARN_MORE": "Learn more about labels",
    "COUNT": "{n} label | {n} labels",
    "SEARCH_PLACEHOLDER": "ലേബലുകൾ തിരയുക...",
    "NO_RESULTS": "No labels found matching your search",
    "SEARCH_404": "ഈ ചോദ്യവുമായി പൊരുത്തപ്പെടുന്ന ഇനങ്ങളൊന്നുമില്ല",
    "LIST": {
      "404": "ഈ അക്കൗണ്ടിൽ ലേബലുകളൊന്നും ലഭ്യമല്ല.",
      "TITLE": "ലേബലുകൾ നിയന്ത്രിക്കുക",
      "DESC": "സംഭാഷണങ്ങൾ ഒരുമിച്ച് ഗ്രൂപ്പുചെയ്യാൻ ലേബലുകൾ നിങ്ങളെ അനുവദിക്കുന്നു.",
      "TABLE_HEADER": {
        "NAME": "പേര്",
        "DESCRIPTION": "വിവരണം",
        "COLOR": "നിറം",
        "ACTION": "പ്രവർത്തനങ്ങൾ"
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "ലേബൽ നാമം",
        "PLACEHOLDER": "ലേബൽ നാമം",
        "REQUIRED_ERROR": "ലേബൽ നാമം ആവശ്യമാണ്",
        "MINIMUM_LENGTH_ERROR": "കുറഞ്ഞ ദൈർഘ്യം 2 ആവശ്യമാണ്",
        "VALID_ERROR": "അക്ഷരമാല, അക്കങ്ങൾ, ഹൈഫൻ, അണ്ടർ സ്‌കോർ എന്നിവ മാത്രമേ അനുവദിക്കൂ"
      },
      "DESCRIPTION": {
        "LABEL": "വിവരണം",
        "PLACEHOLDER": "ലേബൽ വിവരണം"
      },
      "COLOR": {
        "LABEL": "നിറം"
      },
      "SHOW_ON_SIDEBAR": {
        "LABEL": "സൈഡ്‌ബാറിൽ ലേബൽ കാണിക്കുക"
      },
      "EDIT": "എഡിറ്റുചെയ്യുക",
      "CREATE": "സൃഷ്ടിക്കുക",
      "DELETE": "ഇല്ലാതാക്കുക",
      "CANCEL": "റദ്ദാക്കുക"
    },
    "SUGGESTIONS": {
      "TOOLTIP": {
        "SINGLE_SUGGESTION": "Add label to conversation",
        "MULTIPLE_SUGGESTION": "Select this label",
        "DESELECT": "Deselect label",
        "DISMISS": "Dismiss suggestion"
      },
      "POWERED_BY": "Chatwoot AI",
      "DISMISS": "Dismiss",
      "ADD_SELECTED_LABELS": "Add selected labels",
      "ADD_SELECTED_LABEL": "Add selected label",
      "ADD_ALL_LABELS": "Add all labels",
      "SUGGESTED_LABELS": "Suggested labels"
    },
    "ADD": {
      "TITLE": "ലേബൽ ചേർക്കുക",
      "DESC": "സംഭാഷണങ്ങൾ ഒരുമിച്ച് ഗ്രൂപ്പുചെയ്യാൻ ലേബലുകൾ നിങ്ങളെ അനുവദിക്കുന്നു.",
      "API": {
        "SUCCESS_MESSAGE": "ലേബൽ വിജയകരമായി ചേർത്തു",
        "ERROR_MESSAGE": "ഒരു പിശക് ഉണ്ടായിരുന്നു, ദയവായി വീണ്ടും ശ്രമിക്കുക"
      }
    },
    "EDIT": {
      "TITLE": "ലേബൽ എഡിറ്റുചെയ്യുക",
      "API": {
        "SUCCESS_MESSAGE": "ലേബൽ വിജയകരമായി അപ്‌ഡേറ്റുചെയ്‌തു",
        "ERROR_MESSAGE": "ഒരു പിശക് ഉണ്ടായിരുന്നു, ദയവായി വീണ്ടും ശ്രമിക്കുക"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "ഇല്ലാതാക്കുക",
      "API": {
        "SUCCESS_MESSAGE": "ലേബൽ വിജയകരമായി ഇല്ലാതാക്കി",
        "ERROR_MESSAGE": "ഒരു പിശക് ഉണ്ടായിരുന്നു, ദയവായി വീണ്ടും ശ്രമിക്കുക"
      },
      "CONFIRM": {
        "TITLE": "ഇല്ലാതാക്കൽ സ്ഥിരീകരിക്കുക",
        "MESSAGE": "<p><b>ഏജന്റുമാർ</b></p><p> ഒരു <b>ഏജൻറ്</b> നിങ്ങളുടെ ഉപഭോക്തൃ പിന്തുണാ ടീമിലെ ഒരു അംഗമാണ്. </p><p> ഏജന്റുമാർക്ക് നിങ്ങളുടെ ഉപയോക്താക്കളിൽ നിന്നുള്ള സന്ദേശങ്ങൾ കാണാനും മറുപടി നൽകാനും കഴിയും. നിങ്ങളുടെ അക്കൗണ്ടിലുള്ള എല്ലാ ഏജന്റുമാരെയും ഈ പട്ടിക കാണിക്കുന്നു. </ p> <p> ഒരു പുതിയ ഏജന്റിനെ ചേർക്കുന്നതിന് <b> ഏജന്റിനെ ചേർക്കുക </ b> ബട്ടൺ ക്ലിക്കുചെയ്യുക. നിങ്ങൾ ചേർത്ത ഏജന്റിന് അവരുടെ അക്കൗണ്ട് സജീവമാക്കുന്നതിന് ഒരു സ്ഥിരീകരണ ലിങ്കുള്ള ഇമെയിൽ ലഭിക്കും. അതിനുശേഷം അവർക്ക് ചാറ്റ് വൂട്ട് ആക്സസ് ചെയ്യാനും സന്ദേശങ്ങളോട് പ്രതികരിക്കാനും കഴിയും.</p> <p> ചാറ്റ് വൂട്ടിന്റെ സവിശേഷതകളിലേക്കുള്ള ആക്സസ് ഇനിപ്പറയുന്ന റോളുകളെ അടിസ്ഥാനമാക്കിയുള്ളതാണ്. </p><p> <b>ഏജൻറ്</ b> - ഈ റോൾ‌ ഉള്ള ഏജന്റുമാർ‌ക്ക് ഇൻ‌ബോക്‍സുകൾ‌, റിപ്പോർ‌ട്ടുകൾ‌, സംഭാഷണങ്ങൾ‌ എന്നിവ മാത്രമേ ആക്‌സസ് ചെയ്യാൻ‌ കഴിയൂ. അവർക്ക് മറ്റ് ഏജന്റുമാരുടെയോ അല്ലെങ്കിൽ‌ തങ്ങളുടേയോ സംഭാഷണങ്ങൾ‌ നിർ‌ണ്ണയിക്കാനും സംഭാഷണങ്ങൾ‌ പരിഹരിക്കാനും കഴിയും.</p><p> <b>അഡ്മിനിസ്ട്രേറ്റർ</b> - ഒരു സാധാരണ ഏജന്റിന്റെ പ്രത്യേകാവകാശങ്ങളോടൊപ്പം ക്രമീകരണങ്ങളും ബില്ലിംഗും ഉൾപ്പെടെ നിങ്ങളുടെ അക്കൗണ്ടിൽ ലഭ്യമായ എല്ലാ ചാറ്റ് വൂട്ട് സവിശേഷതകളിലേക്കും ആക്‌സസ് ഉണ്ടായിരിക്കുക. </ p> ",
        "YES": "അതെ, ഇല്ലാതാക്കുക ",
        "NO": "ഇല്ല, സൂക്ഷിക്കുക"
      }
    }
  }
}
